module.exports = __webpack_public_path__ + "static/undraw_begin_chat_c6pj-bd0a2a0d12460a4795aaa3f7d8e03f93.svg";